import "./hotjar-tracker";



// WEBPACK FOOTER //
// ./client/src/core/components/hotjar/index.js